export default {
    /*
     * Columns
     */
    behavior_driver: 'Driver',
    behavior_vehicle: 'Vehicle',
    behavior_riskFactors: 'Risk Factors',
    behavior_riskFactorsPoints: 'Risk Factors (points)',
    behavior_category: 'Category',
    behavior_metric: 'Metric',
    behavior_warningPoints: 'Warning (points)',
    behavior_violationPoints: 'Violation (points)',
    behavior_totalSafetyEvents: 'Total Safety Events',
    behavior_total: 'Total',
    /*
     * Metric Types
     */

    behavior_aggression: 'Aggression',
    behavior_hardBrake: 'Hard Brake',
    behavior_hardTurn: 'Hard Turn',
    behavior_rapidAcceleration: 'Rapid Acceleration',
    behavior_potentialIncident: 'Potential Incident',
    behavior_driverMonitoringSystem: 'Driver Monitoring System (DMS)',
    behavior_dms: '(DMS)',
    behavior_usingPhone: 'Using Phone',
    behavior_smoking: 'Smoking',
    behavior_drowsiness: 'Drowsiness',
    behavior_noSeatbelt: 'No Seatbelt',
    behavior_dayDreaming: 'Day Dreaming',
    behavior_yawn: 'Yawn',
    behavior_asleep: 'Asleep',
    behavior_distracted: 'Distracted',
    behavior_cameraObstructed: 'Camera Obstructed',
    behavior_idleNoDriver: 'Idle No Driver',
    behavior_passengersDetection: 'Passengers Detection',

    behavior_passengerInside: 'Passenger Inside',
    behavior_collisionWarning: 'Collision Warning',
    behavior_cyclistWarning: 'Cyclist Warning',
    behavior_SpeedOver: 'Speed Over',
    behavior_SpeedOverPosted: 'Speed Over Posted',
    behavior_ECUSpeedOver: 'ECU Speed Over',
    behavior_ECUSpeedOverPosted: 'ECU Speed Over Posted',

    behavior_advancedDriverAssistanceSystem: 'Advanced Driver Assistance System (ADAS)',
    behavior_adas: '(ADAS)',
    behavior_forwardCollisionWarning: 'Forward Collision Warning',
    behavior_closeFollowing: 'Close Following',
    behavior_tailgating: 'Tailgating',
    behavior_laneDeparture: 'Lane Departure',
    behavior_stopSignViolation: 'Stop Sign Violation',
    behavior_pedestrianDetection: 'Pedestrian Detection',
    behavior_cyclistDetection: 'Cyclist Detection',
    behavior_vehicleSpeed: 'Vehicle Speed',
    behavior_speedLabel: 'Speed > ',
    behavior_speedingOverPosted: 'Speeding Over Posted',
    behavior_speedOverLow: '1-5 (Low)',
    behavior_speedOverMedium: '6-10 (Medium)',
    behavior_speedOverHigh: '11+ (High)',
    behavior_speedOverLowKph: '2-9 (Low)',
    behavior_speedOverMediumKph: '10-17 (Medium)',
    behavior_speedOverHighKph: '18+ (High)',

    behavior_today: 'Today',
    behavior_yesterday: 'Yesterday',
    behavior_week: 'This Week',
    behavior_lastWeek: 'Last Week',
    behavior_thisMonth: 'This Month',
    behavior_lastMonth: 'Last Month',
    behavior_quarter: 'This Quarter',
    behavior_lastQuarter: 'Last Quarter',
    behavior_custom: 'Custom',
    behavior_last7days: 'Last 7 Days',
    behavior_last15days: 'Last 15 Days',
    behavior_last30Days: 'Last 30 Days',

    behavior_dateToday: 'Today',
    behavior_dateYesterday: 'Yesterday',
    behavior_dateThisWeek: 'This Week',
    behavior_dateLastToday: 'Last Week',
    behavior_dateThisQuarter: 'This Quarter',
    behavior_dateLastQuarter: 'Last Quarter',
    behavior_dateCustom: 'Custom',
    behavior_dateThisMonth: 'This Month',
    behavior_dateLastMonth: 'Last Month',
    behavior_dateLast7days: 'Last 7 Days',
    behavior_dateLast15days: 'Last 15 Days',
    behavior_dateLast30Days: 'Last 30 Days',

    behavior_search: 'Search by {fields}',
    behavior_filterBy: 'Filter By:',
    behavior_tableNoData: 'No data to display in this table.',
    behavior_noDataAvailable: 'No data available for the selected time period.',
    behavior_timeFrame: 'Timeframe',
    behavior_singleUnits: 'Units',
    behavior_drivers: 'Drivers',
}
